/* ============
 * HTTP
 * ============
 *
 * Instance axios partagée par toute l'application. Les intercepteurs et
 * `axios-cancel` sont branchés dans `bootstrap.js`.
 */
import axios from 'axios';

axios.defaults.baseURL = process.env.API_LOCATION;
axios.defaults.headers.common.Accept = 'application/json';

export default axios;
